import moment from 'moment';
import i18n from "@/plugins/vueI18n";
import store from "@/store";

export const localizedDate = (value, format = null) => {

    if (!value) return

    const defaultFormat = format || `${store.state.facilityModule.selectedFacility.dateFormat} ${store.state.facilityModule.selectedFacility.timeFormat}`

    return moment(value).locale(i18n.locale).format(defaultFormat)
}